import { ExtraStateContext } from "..";
import { Box } from "../../../../../../components/box";
import InformationLayout from "../../../../components/layout/InformationLayout";
import { useProcess } from "../../../../process-context";
import FormButton from "./button";
import FormContent from "./content";

const SecurityCardUnitsInformation = () => {
  const { isLongTerm } = useProcess<ExtraStateContext>();

  return (
    <InformationLayout>
      <Box
        title={`Thông tin cấp thẻ KSAN ${isLongTerm ? "dài hạn" : "ngắn hạn"}`}
        className="full-height"
      >
        <FormContent />
        <FormButton />
      </Box>
    </InformationLayout>
  );
};

export default SecurityCardUnitsInformation;
